import { render, staticRenderFns } from "./Jumper.vue?vue&type=template&id=879acf74&scoped=true&"
import script from "./Jumper.vue?vue&type=script&lang=js&"
export * from "./Jumper.vue?vue&type=script&lang=js&"
import style0 from "./Jumper.vue?vue&type=style&index=0&id=879acf74&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "879acf74",
  null
  
)

export default component.exports